// extracted by mini-css-extract-plugin
module.exports = {"title":"style_title__2hmgC","terms":"style_terms__3kuBc","backBtn":"style_backBtn__SF4mp","button_div":"style_button_div__WWEPS"};